module.exports = __webpack_public_path__ + "img/108.3.f76f989b.png";